import { isDefinedArray, reduce } from "et3-type-guards";
import { memoize } from "lodash";
import { computed, observable, runInAction } from "mobx";
import { apiCallGetKhattabaAiClients } from "../../api/khattbat-api/api-call-get-khattaba-ai-clients";
import { DEFAULT_KHATTABAT_AI_FLTER_STATUS_VALUE } from "../../constants/core-constants";
import { getSpecificDateWithDays } from "../../core/et3-date";
import { TCorePage, TGender, TGetKhattabaClients } from "../../Types";
import { TEt3PickerMultipleValue, TEt3PickerSingleValue } from "../../TypesNEW";
import getCorePopUpStore from "../core/core-popup-store";
import getCoreUIStore from "../core/core-ui-store";

class KhattabaAiStore {
  dateMinInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 1, daysAdded: 0 })
  );
  dateMaxInput = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );

  statusFilter = observable.box<TEt3PickerSingleValue>(
    DEFAULT_KHATTABAT_AI_FLTER_STATUS_VALUE
  );
  statsFilter = observable.box<TEt3PickerMultipleValue>([]);
  pageGender = observable.box<TGender>("m");
  userID = observable.box<number>(-1);
  clients = observable.box<TGetKhattabaClients[]>([]);

  setUserID = (value: number) => {
    runInAction(() => {
      this.userID.set(value);
    });
  };

  setStatusFilter = (value: { label: string; value: string }) => {
    runInAction(() => {
      this.statusFilter.set(value);
    });
  };

  setStatsFilter = (value: TEt3PickerMultipleValue) => {
    runInAction(() => {
      this.statsFilter.set(value);
    });
  };

  setPageGender = (gender: TGender) => {
    runInAction(() => {
      this.pageGender.set(gender);
    });
  };

  setClients = (clients: TGetKhattabaClients[]) => {
    runInAction(() => {
      this.clients.set(clients);
    });
  };

  getKhattabaClients = async () => {
    const pageName: TCorePage = "KHATTABAT_CLIENTS";
    this.setClients([]);
    getCoreUIStore().setIsLoading(pageName, true);
    const stats: string[] = isDefinedArray(this.statsFilter.get())
      ? this.statsFilter.get().map((stat) => {
          return stat.value;
        })
      : ["none"];

    const { status, code, data } = await apiCallGetKhattabaAiClients({
      gender: this.pageGender.get(),
      stats,
      applicationStatus: this.statusFilter.get().value,
      startDate: this.dateMinInput.get(),
      endDate: this.dateMaxInput.get(),
      userID: this.userID.get()
    });
    getCoreUIStore().setIsLoading(pageName, false);
    if (status === "OK") {
      const activeKhattabat = reduce(() => data, []);
      this.setClients(activeKhattabat);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
  
  getClientsCount = computed(() => {
    return this.clients.get().length;
  });
}

export const getKhattabaAiStore = memoize(
  () => {
    return new KhattabaAiStore();
  },
  () => 1
);

export default getKhattabaAiStore();
